import CheckoutItem from "@components/CheckoutItem/CheckoutItem";
import CheckoutItemFree from "@components/CheckoutItem/CheckoutItemFree";
import type { CartItem } from "@server/gql/graphql";
import type { Dictionary } from "types/common";

import { envConfig } from "@/config/env";

const CheckoutItems = ({
  items,
  dictionary,
  removeItem,
  updateItem,
  locale,
  loading,
}: {
  items: CartItem[];
  dictionary: Dictionary;
  removeItem: (item: CartItem) => void;
  updateItem: (item: CartItem) => void;
  locale?: string;
  loading?: boolean;
}) => {
  const itemsWithoutDynamicFreight = items.filter(
    (item) =>
      item.partNo !== envConfig.NEXT_PUBLIC_NSHIFT_DYNAMIC_FREIGHT_PARTNO,
  );

  const giftItems = items
    .flatMap((item) => [item, ...(item.underlyingItems || [])])
    .filter((item) => item.price === 0);

  return (
    <div className="divide-y @container">
      {itemsWithoutDynamicFreight.map((item) => {
        if (item.price === 0) return null;
        return (
          <CheckoutItem
            key={item.id}
            dictionary={dictionary}
            updateItem={updateItem}
            removeItem={removeItem}
            loading={loading}
            cartItem={item}
          />
        );
      })}
      {giftItems.map((item) => (
        <CheckoutItemFree
          key={item.id}
          item={item}
          locale={locale}
          dictionary={dictionary}
        />
      ))}
    </div>
  );
};

export default CheckoutItems;
